"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeOut = void 0;
class EventTypeOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeOut.attributeTypeMap;
    }
}
exports.EventTypeOut = EventTypeOut;
EventTypeOut.discriminator = undefined;
EventTypeOut.attributeTypeMap = [
    {
        "name": "archived",
        "baseName": "archived",
        "type": "boolean",
        "format": ""
    },
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "description",
        "baseName": "description",
        "type": "string",
        "format": ""
    },
    {
        "name": "featureFlag",
        "baseName": "featureFlag",
        "type": "string",
        "format": ""
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string",
        "format": ""
    },
    {
        "name": "schemas",
        "baseName": "schemas",
        "type": "{ [key: string]: any; }",
        "format": ""
    },
    {
        "name": "updatedAt",
        "baseName": "updatedAt",
        "type": "Date",
        "format": "date-time"
    }
];
//# sourceMappingURL=EventTypeOut.js.map